import { WorkerJobStatus } from '@/jbi-shared/types/cplus-worker.types';
import { AxiosError } from 'axios';
import { Job } from 'bull';

export interface ApiState {
  loading: boolean;
  success: boolean;
  error: AxiosError | Error | null;
}

type WorkerJob<T> = Job<{
  id: number;
  returnvalue: T;
}>;

export type CitationImportJobReturnValue = {
  jobId: string;
  status: WorkerJobStatus;
  message: unknown;
  metadata: {
    total: number;
    success: number;
    failed: number;
  };
};

export type CitationImportJob = WorkerJob<CitationImportJobReturnValue>;

export type CitationsImportState = {
  ready: boolean;
  uploading: boolean;
  processing: boolean;
  success: boolean;
  partial: boolean;
  error: AxiosError | Error | null;
  uploadTimeout: boolean;
  processingTimeout: boolean;

  workerInfo?: CitationImportJob;
};

export const defaultApiState: ApiState = {
  loading: false,
  success: false,
  error: null
};

export const defaultCitationsImportState: CitationsImportState = {
  ready: false,
  uploading: false,
  processing: false,
  success: false,
  partial: false,
  error: null,
  uploadTimeout: false,
  processingTimeout: false,
  workerInfo: undefined
};

export interface PaginatedApiResponse<T> {
  total_count: number;
  incomplete_results: boolean;
  items: T[];
  facets?: Facet[];
}

export interface PaginationQuery {
  sort?: string;
  order?: 'asc' | 'desc';
  page?: number;
  per_page?: number;
}

export interface Facet {
  name: FacetTypes;
  keysAndCount: SearchFacet[];
}

export interface SearchFacet {
  key: string;
  doc_count: number;
  displayName?: string;
}

export enum FacetTypes {
  Author = 'author',
  DocumentType = 'documentType',
  Nodes = 'nodes',
  AssignedUser = 'assignedUser'
}

// tslint:disable-next-line:ban-types
export type AnyFunction = Function;
